const languages = {
    en: "English",
    hi: "Hindi",
    id: "Indonesian",
    es: "Spanish",
    fr: "French",
    de: "German",
    zh: "Chinese",
    vi: "Vietnamese",
    th: "Thai",
    ja: "Japanese",
    tl: "Tagalog (Filipino)",
    af: "Afrikaans",
    ko: "Korean",
    mi: "Maori",
    ar: "Arabic",
    ru: "Russian",
    fi: "Finnish",
    nl: "Dutch (Netherlands)"
};

export default languages;